import home1YinliuLogo from '@/assets/img/home1_yinliu_logo.png'

export default {
  data () {
    return {
      //  引导页\贷超\被拒引流产品名称
      productName: 'WTL',
      //  引导页\贷超\被拒下载链接
      downloadUrl: 'https://apps.apple.com/id/app/wtl-pinjaman-online/id6757323483?l=id',
      home1_yinliu_logo: home1YinliuLogo
    }
  },
  methods: {

  }
}
